module.exports = __webpack_public_path__ + "static/media/goddess-poster.20282547.png";